import axios from '@/lib/axios'
import { useMutation } from '@tanstack/vue-query'
import { ref } from 'vue'
import { ToastInterface, useToast } from 'vue-toastification'

interface Params {
	requestId: number
}

type ResendNotifications = {
	recipients: string[]
}

const resendNotifications = async (
	params: Params,
	recipients: ResendNotifications,
	toast: ToastInterface
) => {
	try {
		const { data } = await axios.post(
			`/api/internal/requests/${params.requestId}/resend-notifications`,
			recipients
		)

		return data
	} catch (error: any) {
		// ⚠️ Se relanza. Sin esto el `catch` se tragaba el error y la promesa resolvía
		// bien, así que quien llama seguía de largo y cantaba «notificaciones enviadas»
		// encima del toast rojo. Ahora la mutación falla cuando el reenvío falla.
		toast.error(
			error.response?.data?.message ??
				'No se pudo reenviar la confirmación. Intenta de nuevo.'
		)

		throw error
	}
}

const useRequestResendNotifications = (props: Params) => {
	const toast = useToast()
	const requestId = ref(props.requestId || 0)

	const resendNotificationMutation = useMutation({
		mutationKey: ['resendNotifications'],
		mutationFn: (emails: ResendNotifications) =>
			resendNotifications(
				{
					requestId: requestId.value,
				},
				emails,
				toast
			),
	})

	return {
		resendNotificationMutation,
		resendNotificationsLoading: resendNotificationMutation.isLoading,
		resendNotificationAsync: resendNotificationMutation.mutateAsync,
		requestId,
	}
}

export default useRequestResendNotifications
